import { useState, useEffect } from "react";

const API_BASE = process.env.REACT_APP_API_URL || "";

const DEFAULT_CENTS = 599;

export function formatFee(cents) {
  if (!Number.isFinite(cents)) return "";
  return `$${(cents / 100).toFixed(2)}`;
}

// The admin-configured filing fee (app_settings.filing_fee_cents — see
// backend/src/lib/aiProviders.js readFeeConfig). Returns { cents, label } so
// copy can render the live price instead of a hardcoded one. Falls back to the
// $5.99 default while loading / on error so no page ever shows a blank price.
export function useFeeConfig() {
  const [fee, setFee] = useState({ cents: DEFAULT_CENTS, label: formatFee(DEFAULT_CENTS) });

  useEffect(() => {
    let cancelled = false;
    fetch(`${API_BASE}/api/ai/fee-config`)
      .then((res) => res.json())
      .then((data) => {
        if (!cancelled && Number.isFinite(data?.cents)) {
          setFee({ cents: data.cents, label: formatFee(data.cents) });
        }
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  return fee;
}
